import Link from 'next/link';
import { Dispatch, FC, SetStateAction } from 'react';
import useTranslation from 'next-translate/useTranslation';
import { ChevronRight, MoreVertical } from '@eqi-investimentos/icons/web';
import { Box, Flex, Text } from '@eqi-investimentos/react';
import { Button } from '@chakra-ui/react';
import { PATHS } from '@/config/paths';
import { IconButton } from '@/components/atoms/IconButton';
import { CardAssetRecomendationData } from '.';
export const BackFace: FC<BackFaceProps> = ({
  data,
  handleInvestIn,
  setIsShowingFront
}) => {
  const {
    t
  } = useTranslation('common');
  const assetName = data.name.length > 8 ? `${data.name.slice(0, 8)}...` : data.name;
  return <Box pos="relative" w="13.25rem" h="8.75rem" p="0.5rem" gap="12" borderRadius="0.625rem" bgColor="content.alwaysDark" onMouseLeave={() => setIsShowingFront(() => true)} data-sentry-element="Box" data-sentry-component="BackFace" data-sentry-source-file="BackFace.tsx">
      <Flex pos="relative" justifyContent="flex-end" px="2.5" pt="2.5" pb="1rem" data-sentry-element="Flex" data-sentry-source-file="BackFace.tsx">
        <IconButton icon={MoreVertical} ariaLabel="Inverter" onButtonClick={() => setIsShowingFront(() => true)} iconProps={{
        w: 22,
        h: 22,
        transform: 'rotate(90deg)',
        color: 'action.active.brandLight',
        _hover: {
          color: 'content.brand'
        }
      }} data-sentry-element="IconButton" data-sentry-source-file="BackFace.tsx" />
      </Flex>
      <Flex flexDir="column" px="4" gap="0.5rem" data-sentry-element="Flex" data-sentry-source-file="BackFace.tsx">
        <Button onClick={() => handleInvestIn(data)} variant="ghost" display="flex" justifyContent="space-between" alignItems="center" px="0" w="full" h="1.25rem" color="action.active.brandLight" transition="0.5s all ease-in" _hover={{
        color: 'content.brand'
      }} sx={{
        _hover: {
          svg: {
            color: 'action.active.brandLight'
          },
          p: {
            color: 'action.active.brandLight'
          }
        }
      }} data-sentry-element="Button" data-sentry-source-file="BackFace.tsx">
          <Option content={`${t('screens.recommendations.cardRecommendation.investIn')} ${assetName}`} data-sentry-element="Option" data-sentry-source-file="BackFace.tsx" />
        </Button>
        <Flex as={Link} href={PATHS.investments.index + `?busca=${data?.ticker}`} justifyContent="space-between" alignItems="center" px="0" w="full" h="1.25rem" color="action.active.brandLight" transition="0.5s all ease-in" _hover={{
        color: 'content.brand'
      }} sx={{
        _hover: {
          svg: {
            color: 'action.active.brandLight'
          },
          p: {
            color: 'action.active.brandLight'
          }
        }
      }} data-sentry-element="Flex" data-sentry-source-file="BackFace.tsx">
          <Option content={t('screens.recommendations.cardRecommendation.seeRecommendations')} data-sentry-element="Option" data-sentry-source-file="BackFace.tsx" />
        </Flex>
      </Flex>
    </Box>;
};
const Option = ({
  content
}: {
  content: string;
}) => <>
    <Flex flex="1" alignItems="center" gap="4" color="inherit" data-sentry-element="Flex" data-sentry-source-file="BackFace.tsx">
      <Text fontSize="xs" fontWeight="semibold" lineHeight="0.875rem" color="inherit" data-sentry-element="Text" data-sentry-source-file="BackFace.tsx">
        {content}
      </Text>
    </Flex>
    <ChevronRight w="18" h="18" color="inherit" data-sentry-element="ChevronRight" data-sentry-source-file="BackFace.tsx" />
  </>;
type BackFaceProps = {
  data: CardAssetRecomendationData;
  handleInvestIn: (data: CardAssetRecomendationData) => void;
  setIsShowingFront: Dispatch<SetStateAction<boolean>>;
};